import React from "react";
// import Head from "next/head"; // Eliminado porque no es Next.js
import Navbar from "./navbar";
import Footer from "./footer";
import HeroComex from "./HeroComex";
import BeneficiosComex from "./BeneficiosComex";
import MarcasConfian from "./MarcasConfian";
import InnovarAutomotriz from "./InnovarAutomotriz";
import HeroContacto from "./HeroContacto";
import TestimoniosComex from "./TestimoniosComex";
import VideoComex from "./VideoComex";
import Switcher from "./switcher";
import FormHosb from "./FormHubSpot";
import SkeletonLoader from "./SkeletonLoader";

export default function Ejemplo1(props) {
  // Props directos de Strapi
  const { Hero, box, contacto, marcas, video, testimonio, seo } = props;
  const urlApi = "https://api.institucional.global.sidom.io";

  return (
    <>
      {/* Meta SEO */}
      {/*
      <Helmet>
        <title>{seo?.title || "Título por defecto"}</title>
        <meta name="description" content={seo?.description || "Descripción por defecto"} />
        {seo?.image?.data?.attributes?.url && (
          <meta property="og:image" content={`${urlApi}${seo.image.data.attributes.url}`} />
        )}
      </Helmet>
      */}

      <Navbar />
      <div className="mx-auto  bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-white">
        <div className="mt-[100px]">
          {Hero?.length ? (
            Hero.map((item, index) => (
              <HeroComex
                key={item.id || index}
                titulo={item.titulo}
                subtitulo={item.text}
                video={item.video?.[0]?.url}
                imagen={
                  item?.img?.[0]?.formats?.thumbnail?.url || item.img?.url
                }
              />
            ))
          ) : (
            <HeroComex titulo="Cargando..." subtitulo="Espere un momento" />
          )}
        </div>

        <section className="">
          {video?.[0] ? (
            <VideoComex
              key={video[0].id}
              video={video[0].video?.[0]?.url}
              controls={video[0]?.control}
              autoPlay={video[0]?.autoplay}
              muted={video[0]?.muted}
              loop={video[0]?.loop}
            />
          ) : (
            <SkeletonLoader text="Cargando video..." />
          )}
        </section>

        <section className="mt-[100px]">
          <h2 className="text-left container text-3xl md:text-4xl lg:text-5xl font-extrabold text-sidom-orange mb-8">
            Beneficios
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 container">
            {box?.length ? (
              box.map((item, index) => (
                <BeneficiosComex
                  key={item.id || index}
                  icon={item.icon?.formats?.thumbnail?.url || item.icon?.url}
                  titulo={item.titulo}
                  subtitulo={item.subtitulo1}
                />
              ))
            ) : (
              <SkeletonLoader text="Cargando beneficios..." />
            )}
          </div>
        </section>

        {/* Marcas */}
        <section className="mt-[100px]">
          {marcas?.length ? (
            marcas.map((item, index) => {
              const marcasArr = Array.isArray(item.img)
                ? item.img.map((marca) => ({
                    src: marca.formats?.thumbnail?.url
                      ? `${urlApi}${marca.formats.thumbnail.url}`
                      : `${urlApi}${marca.url}`,
                    alt: marca.alternativeText || item.titulo,
                  }))
                : item.img?.[0]
                ? [
                    {
                      src: item.img[0].formats?.thumbnail?.url
                        ? `${urlApi}${item.img[0].formats.thumbnail.url}`
                        : `${urlApi}${item.img[0].url}`,
                      alt: item.titulo,
                    },
                  ]
                : [];

              return (
                <MarcasConfian
                  key={item.id || index}
                  titulo={item.titulo}
                  marcas={marcasArr}
                />
              );
            })
          ) : (
            <SkeletonLoader text="Cargando marcas..." />
          )}
        </section>

        {contacto?.length > 0 && (
          <section className="">
            {contacto.map((item, index) => (
              <HeroContacto
                key={item.id || index}
                titulo={item.titulo}
                buttonText="Solicitar DEMO"
                svg={
                  item.svg?.[0]?.formats?.thumbnail?.url || item.svg?.[0]?.url
                }
                img={
                  item.img?.[0]?.formats?.thumbnail?.url || item.img?.[0]?.url
                }
              />
            ))}
          </section>
        )}

        {testimonio?.length > 0 && (
          <section className="my-[100px]">
            <TestimoniosComex testimonios={testimonio} />
          </section>
        )}

        <section className="">
          <FormHosb />
        </section>
      </div>

      <Switcher />
      <Footer />
    </>
  );
}
